
import '../App.css';
import Header from '../components/Header';
import EventGallery from '../components/EventGallery';
import Footer from '../components/Footer';
function App() {
  return (
    <div className="App">

    <Header/> 
    <EventGallery/>
    
    <Footer/>
    </div>
  );
}

export default App;
